import {
    FETCH_WORKKARD_OWNER_LIST_REQUEST_SUCCESS,
    CHANGE_WORKKARD_OWNER_RESET_TO_INITIAL_STATE,
    BULK_VALIDATE_WORKKARD_IDS_CHANGE_OWNER_REQUEST_SUCCESS,
    BULK_VALIDATE_WORKKARD_IDS_CHANGE_OWNER_REQUEST_ERROR,
    FETCH_ACTIVITY_OWNER_LIST_REQUEST_SUCCESS,
    CHANGE_ACTIVITY_OWNER_RESET_TO_INITIAL_STATE,
    BULK_VALIDATE_ACTIVITY_IDS_CHANGE_OWNER_REQUEST_SUCCESS,
    FETCH_ACTIVITY_OWNER_LIST_REQUEST_ERROR,
    CHANGE_ACTIVITY_OWNER_REQUEST_ERROR,
    FETCH_WORKKARD_OWNER_LIST_REQUEST_ERROR,
    CHANGE_WORKKARD_OWNER_REQUEST_ERROR
} from './actionConstants';



const initialState = {
    currentSponsor:{},
    sponsors:[]
}

const changeWorkkardOwner = function(state={}, action){
    switch(action.type){
        case FETCH_WORKKARD_OWNER_LIST_REQUEST_SUCCESS :

        const changeWorkkardOwner = Object.assign({}, state.changeWorkkardOwner, action.payload)
            return Object.assign(
                {},
                state,
                changeWorkkardOwner
            );

        case CHANGE_WORKKARD_OWNER_RESET_TO_INITIAL_STATE :
            return initialState;

        case BULK_VALIDATE_WORKKARD_IDS_CHANGE_OWNER_REQUEST_SUCCESS:
            return Object.assign(
                {},
                state,
                {
                    totalWorkkardsCount : action.payload.TotalCount,
                    validWorkkardsCount : action.payload.ValidCount
                }
            )

        case BULK_VALIDATE_WORKKARD_IDS_CHANGE_OWNER_REQUEST_ERROR:
            return initialState

        case FETCH_WORKKARD_OWNER_LIST_REQUEST_ERROR: {
            return Object.assign({}, state, action.payload);
        }
        
        case CHANGE_WORKKARD_OWNER_REQUEST_ERROR: {
            return Object.assign({}, state, action.payload);
        }



        default :
            return state;
    }
}


const  changeActivityOwner = function(state = {}, action) {
    switch (action.type) {
        case FETCH_ACTIVITY_OWNER_LIST_REQUEST_SUCCESS:
        const changeActivityOwner = Object.assign({}, state.changeActivityOwner, action.payload)
            return Object.assign(
                {},
                state,
                changeActivityOwner
            );
        case BULK_VALIDATE_ACTIVITY_IDS_CHANGE_OWNER_REQUEST_SUCCESS:
            return Object.assign(
                {},
                state,
                {
                    totalActCount: action.payload.TotalCount,
                    validActCount: action.payload.ValidCount,
                    validAct: action.payload.ValidIds
                }
            )
        case FETCH_ACTIVITY_OWNER_LIST_REQUEST_ERROR : {
            return Object.assign({}, state, action.payload);
        }

        case CHANGE_ACTIVITY_OWNER_REQUEST_ERROR : {
            return Object.assign({}, state, action.payload);
        }

        case CHANGE_ACTIVITY_OWNER_RESET_TO_INITIAL_STATE:
            return initialState;

        default:
            return state;
    }
}

export {
    changeWorkkardOwner,
    changeActivityOwner
}